'use strict';

var Backbone = require('backbone');

/**
 * View-Model for {@link manage/details/ports/PortsDetailsView}.
 */
module.exports = Backbone.Model.extend({});
